import React from 'react';

import { Grid, Typography } from '@mui/material';

import { DynamicBarChart } from 'src/App/Dashboards/Market/Components/Charts';
import { BarDataCardPropTypes } from 'src/interfaces/iproptypes';
import { InfoButton } from 'src/App/Dashboards/Market/Components/Buttons';
import UnlockButton from '../CTA/UnlockButton';

const BarDataCard = ({
  title,
  tooltipContent,
  data,
  orientation,
  unit,
  label,
  graphHeight,
  barColor,
  barAccentColor,
  isDisabled,
  handleOnSampleClick,
  tooltipTextSuffix,
  getTooltipSuffix,
  isCurrency,
  parent,
  addSignPrefix = false,
  useRefToSaveGrapgCopy,
}: BarDataCardPropTypes) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
      item
      style={{ position: 'relative' }}
    >
      <Typography
        variant="body1"
        className="subHeadings"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}
      >
        {title} {tooltipContent && <InfoButton tooltipContent={tooltipContent} />}
      </Typography>

      <Grid item sx={{ width: '100%' }} ref={useRefToSaveGrapgCopy}>
        <DynamicBarChart
          layout={orientation}
          data={data}
          unit={unit}
          label={label}
          height={graphHeight}
          barColor={barColor}
          barAccentColor={barAccentColor}
          tooltipTextSuffix={tooltipTextSuffix}
          getTooltipText={getTooltipSuffix}
          isCurrency={isCurrency}
          parent={parent}
          addSignPrefix={addSignPrefix}
        />
      </Grid>

      {isDisabled && (
        <UnlockButton
          fontSizeHeading="small"
          handleOnSampleClick={handleOnSampleClick ? handleOnSampleClick : () => {}}
          noBackdrop={true}
        />
      )}
    </Grid>
  );
};

export default React.memo(BarDataCard);
